import { Box } from '@chakra-ui/react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { AppToaster, ReleaseNotificationBar, useAuth } from '@invara-dev/react-base';
import { useEffect } from 'react';
import { ErrorContainer } from './ErrorContainer';
import { MopspotUser } from './globalModels/user/mopspotUser';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { InstallAppBanner } from './components/common/InstallAppBanner';
import { ChakraRootProvider } from './theme/provider';
import { useNavWithRouting } from './routes/AppRouter';
import { API_URL } from './util/config';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnMount: true,
      refetchOnWindowFocus: true
    }
  }
});

export const App = () => {
  const { initUser, hasLoaded } = useAuth<MopspotUser>();
  const appRouter = createBrowserRouter(useNavWithRouting());

  useEffect(() => {
    async function initAuth() {
      await initUser();
    }

    initAuth();
  }, []);

  return (
    <ChakraRootProvider>
      <AppToaster />
      <InstallAppBanner />
      <Box maxHeight={'100vh'}>
        <QueryClientProvider client={queryClient}>
          <ReactQueryDevtools initialIsOpen={false} />
          <ReleaseNotificationBar apiBaseUrl={API_URL} />
          <ErrorContainer>{hasLoaded && <RouterProvider router={appRouter} />}</ErrorContainer>
        </QueryClientProvider>
      </Box>
    </ChakraRootProvider>
  );
};
